var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Hier siehst du mit welchem Konto und Gerät du online bist. ")])}
var staticRenderFns = []

export { render, staticRenderFns }